let dilithiumKeyParam = [
  'ML-DSA-44',
  'ML-DSA-65',
  'ML-DSA-87'
]

export default dilithiumKeyParam
